export const formatNumber = (number: number | null | undefined) => {
	if (number === null || number === undefined) {
		return "-";
	}

	// Convert to fixed decimal first, then add commas
	const fixedNumber = Number(number).toFixed(2);
	return fixedNumber.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};